import 'normalize.css'
import './static/fonts/fonts.css'
;(function(document) {
  document.body.classList.add('has-js')
})(window.document)
